export default __webpack_public_path__ + "static/media/hht1_storybook_14.f49005c9.png";